import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { resetLogin } from '../Shared/UserContext/Actions';
import UserContext from '../Shared/UserContext';
import { useTranslation } from 'react-i18next';
import { securePost } from '../config/api';
import ModuleWrapper from './ModuleWrapper';
import settingIcon from '../icons/settingsB.svg';
import userIcon from '../icons/userBlue.svg';
import logoutIcon from '../icons/log-out.svg';
import ChevronDownIcon from '../icons/chevron-down.svg';
import deleteIcon from '../icons/x-circleB.svg';
import SnackbarNotification from './SnackbarNotification';

const LoggedUserCard = () => {
  const [showModule, setShowModule] = useState(false);
  const [moduleType, setModuleType] = useState(null);
  const { t } = useTranslation();
  const history = useHistory();
  const { dispatch } = useContext(UserContext);
  const { state: { user, role, token } } = useContext(UserContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null); 
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const showSnackbar = (message, severity = 'success', manual = false) => {
    setSnackbar({ open: true, message, severity, manual });
  };

const fullName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() || '—';
const initials = `${user?.firstName?.[0] ?? ''}${user?.lastName?.[0] ?? ''}`.toUpperCase() || '•';
const displayRole = t(`roles.${role}`)

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleProfilePopup = () => {
    setModuleType("profile");
    setShowModule(true);
  };

  const handleSettingsPopup = () => {
    setModuleType("settings");
    setShowModule(true);
  };

  const handleModuleClose = (action = "cancel") => {
    setShowModule(false);
  };

  const handleRequestDeleteTestData = async () => {
    console.log('delete test data');
    try {
    const response = await securePost('/grayClient/deleteTrialData', {});
    showSnackbar(t(`confirmation.testDataDeleteRequest`), 'success');
    } catch (error) {
      console.error('Error deleting test data:', error);
      showSnackbar(t(`failure.testDataDelete`), 'error');
    }
  };

  const logOut = () => {
    localStorage.clear();
    dispatch(resetLogin());
    history.push('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef}>
      <div
        style={{
          flexShrink: 0,
          flexGrow: 0,
          maxWidth: '300px',
        }}
        className="flex items-center space-x-2 px-4 py-1 rounded-lg backdrop-blur cursor-pointer"
        onClick={toggleDropdown}
      >
        <div className="flex items-center justify-center w-10 h-10 bg-gray-700 text-white rounded-full font-bold text-lg mr-3">
          {initials}
        </div>
        <div>
          <p className="m-0 text-sm font-bold text-[#38485C]">{fullName}</p>
          <p className="m-0 text-xs font-semibold text-primary">{displayRole}</p>
        </div>
        <div>
          <img src={ChevronDownIcon} alt="Chevron Down" className={`h-5 w-5 transform transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />

        </div>

        {isDropdownOpen && (
          <div className="absolute top-14 right-5 mt-2 w-48 bg-white shadow-lg rounded-lg py-2 z-50 border border-[#F7F7F7]">
            <button
              onClick={handleProfilePopup}
              className="flex items-center w-full px-4 py-2 text-[14px] text-[#043F88] font-semibold hover:bg-gray-100"
            >
              <img src={userIcon} alt="Profile Icon" className="w-4 h-4 mr-2" />
              {t(`actions.profile`)}
            </button>
            {role === 'ROLE_ADMIN' && (
              <button
                onClick={handleSettingsPopup}
                className="flex items-center w-full px-4 py-2 text-[14px] text-[#043F88] font-semibold hover:bg-gray-100"
              >
                <img src={settingIcon} alt="Settings Icon" className="w-4 h-4 mr-2" />
                {t(`actions.settings`)}
              </button>
            )}
            <button
              onClick={handleRequestDeleteTestData}
              className="flex items-center w-full px-4 py-2 text-[14px] text-[#043F88] font-semibold hover:bg-gray-100"
            >
              <img src={deleteIcon} alt="Delete Icon" className="w-4 h-4 mr-2" />
              {t(`actions.deleteTestData`)}
            </button>
            <button
              onClick={logOut}
              className="flex items-center w-full px-4 py-2 text-[14px] text-[#EF476F] font-semibold hover:bg-gray-100"
            >
              <img src={logoutIcon} alt="Logout Icon" className="w-4 h-4 mr-2" />
              {t(`actions.logout`)}
            </button>
          </div>
        )}
      </div>

      {showModule && (
        <ModuleWrapper
          moduleType={moduleType}
          mode={"add"}
          onClose={handleModuleClose}
          initialValues={{}}
        />
      )}
      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        manual={snackbar.manual}
      />
    </div>
  );
};

export default LoggedUserCard;
